import RentInfo from "./UI/RentIntro";

export default RentInfo